export const getAllPartners = (res, setNewPartnerList) => {
    let partnerObj = {};
    if(res?.inwardXflow){
        partnerObj.inwardXflow = true
    }
    if(res?.outwardIDFC){
        partnerObj.outwardIDFC = true
    }
    if(res?.inwardIDFC){
        partnerObj.inwardIDFC = true
    }
    if(res?.inwardYes){
        partnerObj.inwardYes = true
    }
    if(res?.inwardPayglocal){
        partnerObj.inwardPayglocal = true
    }
    if(res?.inwardDBS){
        partnerObj.inwardDBS = true
    }
    if(res?.outwardDBS){
        partnerObj.outwardDBS = true
    }
    if(res?.outwardYes){
        partnerObj.outwardYes = true;
    }
    if(res?.outwardRBL){
        partnerObj.outwardRBL = true
    }
    if(res?.inwardRBL){
        partnerObj.inwardRBL = true
    }

    setNewPartnerList(partnerObj);
}